import React from 'react'
import Root from 'features/app/root'
import { createRoot } from 'react-dom/client'

import './assets/sass/_reset.scss'
import './assets/sass/_common.scss'

createRoot(document.getElementById('root')).render(<Root />)
